import React, { Component } from 'react';
import { isEmpty } from "lodash";
import FileSAV from '../../../../commonModules/interface/FileSAV';
import AudioPlayerSAV from '../../../../commonModules/interface/AudioPlayerSAV';
import { TableLayout } from '../containers/Layout';
import { TableBody, TableRow, TableCell,Box } from '@material-ui/core';

import { TimeLineBlock } from '../../../../commonModules/interface/TimeLineMui';
import { Timeline } from '@material-ui/lab';
import {  HighlightOffRounded, VerifiedUserRounded, HealingRounded, UpdateRounded, DeleteSweepRounded, StorefrontRounded,FindInPageRounded, InfoRounded ,TextRotateUp} from '@material-ui/icons';

const USERTYPE = {
    "tech": {icon: <HealingRounded  />, title: "En Réparation", color: "lightAmber"},
    "operator": {icon: <UpdateRounded />, title: "En Attente", color:"lightBlue"},
    "repaired": {icon: <VerifiedUserRounded />, title: "Réparé", color:"teal"}, 
    "hs": {icon: <HighlightOffRounded />, title: "Hors service", color:"lightRed"},
    "add_in_bin": {icon: <DeleteSweepRounded />, title: "Jeté", color:"darkRed"},
    "change_store": { icon: <StorefrontRounded />, title: "Changement de magasin" , color:"blue"},
    "global": { icon: <FindInPageRounded />, title: "Analyse Globale", color:"green" },
    "info": { icon: <InfoRounded />, title: "Information complémentaire" , color:"lightGreen"},
    "reinstall": { icon: <TextRotateUp/>, title: "Reinstallation" },
    "resell": { icon: <TextRotateUp/>, title: "Revente" },
      
}

class TimeLineSAV extends Component {
    state = {  }
    
    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    setTimeLine = () => {
        console.log('====================================');
        console.log("SET TIME LINE", this.props.history);
        console.log('====================================');

        return this.props.history.map( action => {
            let type= ""
            switch (action.action_type) {
                case "change_store":
                    type = "change_store"
                    break;
                case "global":
                    type = "global"
                    break;
                case "info":
                    type = "info"
                    break;
                case "reinstall":
                    type = "reinstall"
                    break;
                case "resell":
                    type = "resell"
                    break;
                default:
                    break;
            }
            
            // Pour la gestion des anciens types
            if (type === ""){
                if(action.action_status === 'WAITING'){
                    type ='operator'
                } else if(action.action_status === 'IN_REPAIR'){
                    type = 'tech'
                } else if(action.action_status === 'REPAIRED'){
                    type ='repaired'
                } else if(action.action_status === 'HS'){
                    type ='hs'
                } else if(action.action_status === 'THROW'){
                    type ='add_in_bin'
                }
            }
            
            let form = action.action_form ? JSON.parse(action.action_form) : null

            let content = action.action_comment
            let imagecontent = ""
            if (!isEmpty(action.action_files)){
                imagecontent = 
                    <p>Piece(s) Jointe(s) : {action.action_files.map( file => (
                        <FileSAV 
                            name={
                                `RAPPORT_${action.action_ts.split("T")[0]}`
                            } 
                            src={this.replaceAll(file.filename, "/", "_")} 
                            mime={file.filetype} 
                            other 
                            sav
                        /> 
                    ))}
                    </p>
                content = <div>
                {action.action_comment}
                {imagecontent}
                </div>
            } 
            
            if (form) {
                content = <div>
                {action.action_comment}
                <TableLayout>
                    <TableBody>
                        {Object.keys(form).map(key => (
                            <TableRow>
                                <TableCell>{key}</TableCell>
                                <TableCell>{form[key]}</TableCell>
                            </TableRow>
                        )) }
                    </TableBody>
                </TableLayout>
                {imagecontent}
            </div>

            }

            if (action.action_audio && action.action_audio.audioId) {
                content = <div>
                    {content}
                    <AudioPlayerSAV audio={action.action_audio} />
                </div>
            }

            let step = {
                date: new Date(action.action_ts).toLocaleString('fr-FR') || action.action_ts,
                icon: USERTYPE[type].icon,
                title: USERTYPE[type].title,
                color: USERTYPE[type].color,
                //title: action.action_status +" "+action.action_comment, //USERTYPE[item.userType].title,
                content: content,
            }
            return (
                <TimeLineBlock step={step} />
            )
        })
    }
    render() {
        console.log('====================================');
        console.log("TIME LINE SAV HISTORY", this.props.history);
        console.log('====================================');
        return (
            
            <Box p={1}>
                {/* <Timeline  align="altenate"> */}
                <Timeline >
                    {this.props.history && 
                        this.setTimeLine()
                    }
                
                </Timeline>
            </Box>
        );
    }
}

export default TimeLineSAV;